import { render, staticRenderFns } from "./chinaMapbaidu.vue?vue&type=template&id=55d0046e&"
import script from "./chinaMapbaidu.vue?vue&type=script&lang=js&"
export * from "./chinaMapbaidu.vue?vue&type=script&lang=js&"
import style0 from "./chinaMapbaidu.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports